import {
  ListItemAvatar as MuiListItemAvatar,
  ListItemAvatarProps as MuiListItemAvatarProps,
} from '@mui/material';

export type ListItemAvatarProps = MuiListItemAvatarProps;

export const ListItemAvatar = MuiListItemAvatar;
